<template>
  <div class="simple-container">
    <div :class="bgSimple" ref="bgSimple" id="SimpleView">
      <div :class="`${selectedModelData.category === 5 ? 'bg-home-r-htm' : 'bg-home-r'} ${(selectedModelData.category !== 5 && houseInfo.roomH < 400) ? 'bg-home-r-h2' : ''} ${(selectedModelData.category !== 5 && houseInfo.roomH >= 900) ? 'bg-home-r-h9' : ''}`" id="bghomeR" :style="[selectedModelData.category === 5 ? {'right' : rightH + 'px'} : false,{'top': topRoomH + 'px'}]">
        <img :src="require('@/assets/parts/simple/' + bgHomeR + '.png')" :style="{'height': bgHomeRHeight + 'px'}">
      </div>
      <div :class="houseInfo.roomH < 400 ? 'bg-home-l-h2' : 'bg-home-l'" :style="[houseInfo.roomH >= 400 ? {'left': leftRoomH + 'px'}:{'right' : rightRoomH + 'px'}, {'top': topRoomH + 'px'}]" v-if="bgHomeL !== ''">
        <img :src="require('@/assets/parts/simple/' + bgHomeL + '.png')" id="bghomeL" :style="{'height': bgHomeLHeight + 'px'}">
      </div>
        <Condition></Condition>
        <SimpleProjectView ref="SimpleFrontView" :blueImgHeight='blueImgHeight' :screenStatus="screenStatus" :manImgHeight="manImgHeight"></SimpleProjectView>
    </div>
    <footer>
      <ResultInformationButton></ResultInformationButton>
    </footer>
  </div>
</template>

<script>
import Condition from '../../condition/condition'
import SimpleProjectView from '../../graph/Simple/simpleProjectView'
import { mapState, mapMutations } from 'vuex'
import ResultInformationButton from '@/view/result/resultInformationButton'
export default {
  name: 'SimpleViewIndex',
  data () {
    return {
      ceilingHFixed: 363,
      mamHeight: 180,
      screenStatus: {
        height: 0,
        top: 0
      }
    }
  },

  watch: {
    drawData: {
      handler (val) {
        let screenPArr = val[0]
        let screenH = screenPArr[3].z - screenPArr[0].z
        let height = (this.ceilingHFixed * screenH) / this.houseInfo.roomH
        let top = (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH > this.ceilingHFixed ? this.ceilingHFixed : (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH
        this.screenStatus = {height, top}
        this.setInitPosition()
      }
    },
    selectedModelData (val) {
      if ((val.category === 4 || val.category === 5) && val.position === 2) {
        this.$router.push('/page/advanceMode')
        this.SET_ISSIMPLE(false)
        this.SET_TABACTIVENAME('Advanced')
        this.SET_POSITION(2)
      }
    }
  },

  components: {
    Condition, SimpleProjectView, ResultInformationButton
  },

  computed: {
    ...mapState(['cateRadio', 'houseInfo', 'drawData', 'graph', 'isSimple', 'initScreenSize', 'screen4Point', 'aspectRatio', 'selectedLensData', 'floor2bottom',
      'selectedModelData']),
    bgSimple () {
      if (this.selectedModelData.category === 5) {
        return 'htm-simple'
      } else {
        if (this.houseInfo.roomH < 400) {
          return 'bm-simple-h2'
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return 'bm-simple-h4'
        } else {
          return 'bm-simple-h9'
        }
      }
    },

    bgHomeR () {
      if (this.selectedModelData.category === 5) {
        return 'home_sofa_c'
      } else {
        if (this.houseInfo.roomH < 400) {
          return 'business_chair_h2_r'
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return 'business_chair_h4_r'
        } else {
          return 'business_chair_h9_r'
        }
      }
    },

    bgHomeL () {
      if (this.selectedModelData.category === 5) {
        return ''
      } else {
        if (this.houseInfo.roomH < 400) {
          return 'business_chair_h2_l'
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return 'business_chair_h4_l'
        } else {
          return 'business_chair_h9_l'
        }
      }
    },

    leftRoomH () {
      let MaxL4 = -30
      let MinL4 = -5
      let MaxL9 = 10
      let MinL9 = 25
      let bili4 = (MaxL4 - MinL4) / (900 - 400) / 10
      let bili9 = (MaxL9 - MinL9) / (2000 - 900) / 10
      if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
        return MaxL4 - (this.houseInfo.roomH - 400) / 0.1 * bili4
      } else {
        return MaxL9 - (this.houseInfo.roomH - 900) / 0.1 * bili9
      }
    },

    rightRoomH () {
      let MinLeft = 770
      let MaxLeft = 805
      let biliL = (MaxLeft - MinLeft) / (400 - 200) / 10
      if (this.selectedModelData.category === 5) {
        return 0
      } else {
        if (this.houseInfo.roomH < 400) {
          return MaxLeft - (200 - this.houseInfo.roomH) / 0.1 * biliL
        }
      }
    },

    rightH () {
      let MaxHTM = 25
      let MinHTM = 295
      let biliHtm = (MinHTM - (MaxHTM)) / (2000 - 200) / 10
      return MaxHTM + (this.houseInfo.roomH - 200) / 0.1 * biliHtm
    },

    topRoomH () {
      let MaxT2 = 560
      let MinT2 = 545
      let MaxHTM = 245
      let MinHTM = 665
      let biliT2 = (MaxT2 - MinT2) / (400 - 200) / 10
      let biliHTM = (MaxHTM - MinHTM) / (2000 - 200) / 10
      if (this.selectedModelData.category === 5) {
        return MaxHTM - (this.houseInfo.roomH - 200) / 0.1 * biliHTM
      } else {
        if (this.houseInfo.roomH < 400) {
          return MaxT2 - (400 - this.houseInfo.roomH) / 0.1 * biliT2
        } else if (this.houseInfo.roomH >= 900) {
          return 608
        } else {
          return 615
        }
      }
    },

    bgHomeLHeight () {
      let MaxH2 = 520
      let MinH2 = 360
      let MaxH4 = 325
      let MinH4 = 270
      let MaxH9 = 335
      let MinH9 = 285
      let biliH2 = (MaxH2 - MinH2) / (400 - 200) / 10
      let biliH4 = (MaxH4 - MinH4) / (900 - 400) / 10
      let biliH9 = (MaxH9 - MinH9) / (2000 - 900) / 10
      if (this.selectedModelData.category === 5) {
        return 0
      } else {
        if (this.houseInfo.roomH < 400) {
          return MaxH2 - (this.houseInfo.roomH - 200) / 0.1 * biliH2
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return MaxH4 - (this.houseInfo.roomH - 400) / 0.1 * biliH4
        } else {
          return MaxH9 - (this.houseInfo.roomH - 900) / 0.1 * biliH9
        }
      }
    },

    bgHomeRHeight () {
      let min = 200
      let max = 2000
      let Maximg = 600
      let Minimg = 50
      let MaxH2 = 520
      let MinH2 = 360
      let MaxH4 = 325
      let MinH4 = 270
      let MaxH9 = 375
      let MinH9 = 325
      let bili = (Maximg - Minimg) / (max - min) / 10
      let biliH2 = (MaxH2 - MinH2) / (400 - 200) / 10
      let biliH4 = (MaxH4 - MinH4) / (900 - 400) / 10
      let biliH9 = (MaxH9 - MinH9) / (2000 - 900) / 10
      if (this.selectedModelData.category === 5) {
        return Maximg - (this.houseInfo.roomH - min) / 0.1 * bili
      } else {
        if (this.houseInfo.roomH < 400) {
          return MaxH2 - (this.houseInfo.roomH - 200) / 0.1 * biliH2
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return MaxH4 - (this.houseInfo.roomH - 400) / 0.1 * biliH4
        } else {
          return MaxH9 - (this.houseInfo.roomH - 900) / 0.1 * biliH9
        }
      }
    },
    blueImgHeight () {
      if (this.isSimple) {
        let h = (this.$refs['bgSimple'] || {}).offsetHeight
        let a = (h - this.ceilingHFixed) * 0.6
        let height = (this.graph.pjY * a) / h
        return height > a ? a : height
      }
    },
    manImgHeight () {
      let height = (this.ceilingHFixed * this.mamHeight) / this.houseInfo.roomH
      return height > this.ceilingHFixed ? this.ceilingHFixed : height
    },
    pjZMin () {
      return 0
    },
    pjZMax () {
      return this.houseInfo.roomH
    }
  },

  mounted () {
  },

  methods: {
    ...mapMutations(['SET_SIMPLEPJTOP', 'PJX', 'PJZ', 'SET_OFFSET', 'SET_ISSIMPLE', 'SET_TABACTIVENAME', 'SET_POSITION']),
    setInitPosition (status) {
      // let wallPlateTopVal = this.graph.pjZ * 1.3 * this.ceilingHFixed / this.houseInfo.roomH
      let wallPlateTopVal = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      if (status || wallPlateTopVal <= 0) {
        // wallPlateTopVal = 0
        this.PJZ(this.pjZMin)
      } else if (wallPlateTopVal >= this.ceilingHFixed) {
        // wallPlateTopVal = this.ceilingHFixed
        this.PJZ(this.pjZMax)
      }
      this.SET_SIMPLEPJTOP(wallPlateTopVal)
      this.$refs['SimpleFrontView'].setPosition()
    }
  }
}
</script>
<style scoped>
.simple-container {
  position: relative;
  border: 2px solid #bdbdbd;
}

/* .bgSimple {
  background: url("../../../assets/parts/simple/bg_business_h2.png") no-repeat;
  background-size: 932px 856px;
  height: 885px;
  position: relative;
  overflow: hidden;
} */

.bm-simple-h2 {
  background: url("../../../assets/parts/simple/bg_business_h2.png") no-repeat;
  background-size: 1280px 885px;
  height: 885px;
  position: relative;
  overflow: hidden;
}

.bm-simple-h4 {
  background: url("../../../assets/parts/simple/bg_business_h4.png") no-repeat;
  background-size: 1280px 885px;
  height: 885px;
  position: relative;
  overflow: hidden;
}

.bm-simple-h9 {
  background: url("../../../assets/parts/simple/bg_business_h9.png") no-repeat;
  background-size: 1280px 885px;
  height: 885px;
  position: relative;
  overflow: hidden;
}

.htm-simple {
  background: url("../../../assets/parts/simple/bg_home.png") no-repeat;
  background-size: 1280px 885px;
  height: 885px;
  position: relative;
  overflow: hidden;
}

footer {
  height: 70px;
  border-top: 1px solid #a3a3a2;
  background: #afafb0;
}

.bg-home-r {
  position: absolute;
  top: 615px;
  left: 555px;
}

.bg-home-l {
  position: absolute;
  top: 615px;
  left: 11px;
  z-index: 333;
}

.bg-home-r-htm {
  position: absolute;
  bottom: 110px;
  right: 90px;
}

.bg-home-r-h2 {
  position: absolute;
  top: 530px;
  left: 610px;
  z-index: 333;
}

.bg-home-l-h2 {
  position: absolute;
  top: 530px;
  /* left: -80px; */
  /* height: 270px; */
  z-index: 333;
}

.bg-home-r-h9 {
  position: absolute;
  top: 608px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/Simple/simpleViewIndex.vue